import { SelectField, type SelectFieldProps } from '@ff-it/form';
import type { ReactElement } from 'react';
import { createOptions, type Option } from 'options';
import { CampaignState, campaignStates } from '../campaign/types';
import { CampaignStateTag } from './CampaignStateTag';

export const campaignStateOptions: Option<CampaignState>[] = createOptions(campaignStates);

type BlockStateProps = Omit<
  SelectFieldProps<Option<CampaignState>, any, any>,
  'options' | 'loadOptions' | 'defaultOptions' | 'simple'
>;
export const formatOptionLabel = ({ value }: Option<CampaignState>) => (
  <CampaignStateTag state={value} appearance="naked" />
);

export function CampaignStateField(props: BlockStateProps): ReactElement {
  return <SelectField options={campaignStateOptions} simple formatOptionLabel={formatOptionLabel} {...props} />;
}
